import React from "react";
import s from "./AuthPanel.pcss";

function AuthPanel({children}) {
    return <div className={s.panel}>{children}</div>;
}

export default AuthPanel;
